import React from 'react'
import actions from 'redux/actions'
import { useEffect, useWillMount, useMemo, useState } from 'sb-hooks'
import cookie from 'js-cookie'
import getRoutes from 'routes'
import Root from 'site/client/containers/Root/Root'


const getGlobals = () => ({
  ...window.__globals__,
  cookies: cookie.getJSON(),
})

const useGlobals = () => {
  const [ globals, setGlobals ] = useState(getGlobals())

  useEffect(() => {
    window.__globals__.initialDevice = window.__globals__.device

    window.__updateGlobals__ = (update = {}) => {
      window.__globals__ = {
        ...window.__globals__,
        ...update,
      }

      setGlobals(getGlobals())

      console.log('globals updated')
    }

    // Update media device
    window.dispatchEvent(new Event('resize'))

    return () => {
      window.__updateGlobals__ = undefined
    }
  }, [])

  return globals
}

const useLocalStorageData = () => {
  // Not useEffect, because it should run before the first client's render
  useWillMount(() => {
    actions.view.pickPage.setSelectedItemsFromStorage()
    actions.view.makeupLandingPage.setSelectedItemsFromStorage()
    actions.view.skincareIntroPage.setSelectedItemsFromStorage()
    actions.view.collectionLandingPage.setProductsFromStorage()

    actions.models.queue.moveCookiesToStorage()
    actions.models.cart.moveCartProductFromCookieToStorage()
    actions.models.fragrance.moveStockNotificationFromCookieToStorage()
  }, [])
}


const RootProvider = ({ store, storeEvents, history, translationMessages, cosmeticsDataStructure }) => {
  const globals = useGlobals()

  useLocalStorageData()

  const routes = useMemo(() => (
    getRoutes({
      features: globals.features,
      abTests: globals.abTests,
      device: globals.device,
      initialDevice: globals.initialDevice,
      cosmeticsDataStructure,
    })
  ), [ globals, cosmeticsDataStructure ])

  return (
    <Root {...{ store, storeEvents, history, translationMessages, globals }}>
      {routes}
    </Root>
  )
}


export default RootProvider
